export const apiName: string = 'tipos-bens';
export const bemTiposRoute: string = 'tipos';
export const bemTiposStorage: string = 'bemTipos';
export const bemTiposModuleName: any = {plural: 'Tipos de Bens', single: 'Tipo de Bem'};


export const bemTiposQueryCategoria: any = {
  "where":{
    "ativo":true,
    "tipo":{"regexp":"/REPLACEHERE/i"},
    "categoriaId": null
  },
  "order":"tipo"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/shared/data.service.ts
 **/